export class serviceWorkerCommunicator {
  init() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js').then(function (reg) {
        console.log('Service Worker Registered!', reg);
      }).catch(function (err) {
        console.log('Service Worker registration failed: ', err);
      });
      navigator.serviceWorker.addEventListener('message', event => {
        console.log(event);
      });
    }
  }
}
